<template>
  <svg viewBox="0 0 1920 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 22.8564H248.724L270.737 4.34006C272.873 2.20283 275.77 1.0014 278.792 1H1920"
      stroke="currentColor"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path d="M248.546 22.6291H0V18H253.887L248.546 22.6291Z" fill="currentColor" />
  </svg>
</template>
